import { gql } from "@apollo/client";

export const GET_ORGANISATIONS = gql`
  query MyQuery {
    msgbox_Organisation(order_by: { Name: asc }) {
      OrganisationId
      Name
      APIAccounts {
        Name
        APIAccountId
      }
    }
  }
`;

export const ADD_BOT_RESPONSE = gql`
  mutation MyMutation(
    $apiAccountId: Int!
    $isDeletable: Boolean!
    $isEnabled: Boolean!
    $keyword: String
    $reply: String!
    $organisationId: Int!
    $botResponseType: String!
    $parentBotReplyId: Int = null
    $order: Int = 0
    $requiresResponse: Boolean = false
    $captureEmailAddress: Boolean = false
    $listMetadata: String = null
    $replyMetadata: String = null
  ) {
    insert_msgbox_BotResponse(
      objects: {
        APIAccountId: $apiAccountId
        IsDeletable: $isDeletable
        IsEnabled: $isEnabled
        Keyword: $keyword
        Reply: $reply
        OrganisationId: $organisationId
        BotResponseType: $botResponseType
        ParentBotReplyId: $parentBotReplyId
        Order: $order
        RequiresResponse: $requiresResponse
        CaptureEmailAddress: $captureEmailAddress
        ListMetadata: $listMetadata
        ReplyMetadata: $replyMetadata
      }
    ) {
      returning {
        BotResponseId
      }
    }
  }
`;

export const GET_INBOXES = gql`
  query getInboxes($apiAccountId: Int!) {
    msgbox_Inbox(where: { APIAccountId: { _eq: $apiAccountId } }) {
      Name
      InboxId
      APIAccount {
        APIAccountId
        Name
      }
      Folders(order_by: { FolderId: asc }) {
        FolderId
        InboxId
        Name
      }
    }
  }
`;

export const GET_USERS = gql`
  query getUsers($orgId: Int!) {
    msgbox_Organisation(where: { OrganisationId: { _eq: $orgId } }) {
      OrganisationId
      Name
      Departments {
        DepartmentInboxes {
          InboxId
        }
        Name
        DepartmentId
        UserDepartments(where: { User: { IsDeleted: { _eq: false } } }) {
          User {
            UserId
            LastName
            FirstName
          }
        }
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getAllUsers {
    msgbox_User(where: { IsBot: { _eq: false } }) {
      LastName
      UserId
      FirstName
      UserDepartments {
        Department {
          Name
          DepartmentId
        }
      }
    }
  }
`;

export const ADD_AUTOMATION = gql`
  mutation addAutomation(
    $orgId: Int!
    $keyword: String!
    $reply: String!
    $assignTo: Int
    $routeTo: Int
    $account: Int!
    $assignToDepartment: Int
    $matchType: String!
    $isEnabled: Boolean!
    $ListMetaData: String
    $ReplyMetaData: String
  ) {
    insert_msgbox_BotResponse_one(
      object: {
        Keyword: $keyword
        Reply: $reply
        AssignTo: $assignTo
        RouteTo: $routeTo
        APIAccountId: $account
        OrganisationId: $orgId
        AssignToDepartment: $assignToDepartment
        BotResponseType: $matchType
        IsEnabled: $isEnabled
        ListMetadata: $ListMetaData
        ReplyMetadata: $ReplyMetaData
      }
    ) {
      Keyword
      BotResponseId
    }
  }
`;

export const GET_RESPONSE_KEYWORDS = gql`
  query getResponses($apiAccounts: [Int!]) {
    msgbox_BotResponse(
      where: { APIAccount: { APIAccountId: { _in: $apiAccounts } } }
    ) {
      BotResponseId
      Keyword
      APIAccount {
        APIAccountId
      }
    }
  }
`;
